<template>
  <div class="player-box">
    <!--        <simpleFlv-->
    <!--                v-if="!isIE"-->
    <!--                ref="simpleFlvRef"-->
    <!--                :videoUrl.sync="videoUrlCopy"-->
    <!--                :controls="false"-->
    <!--                :poster="require('@/assets/images/video_empty.jpg')"-->
    <!--                :serverUrl.sync="serverUrl"-->
    <!--                :videoCode.sync="videoCode"-->
    <!--                @cutAndUploadSuccess="cutAndUploadSuccess">-->
    <!--        </simpleFlv>-->

    <!-- 非IE播放器 -->
    <simpleXgPlayer
      v-if="!isIE"
      ref="xgPlayerRef"
      :videoUrl.sync="videoUrlCopy"
      :controls="false"
      :width="width ? width.toString() : videoWidth.toString()"
      :height="height ? height.toString() : videoHeight.toString()"
      :camDOMid="'camDOMid' + Math.random()"
      :poster="require('@/assets/images/video_empty.jpg')"
      :serverUrl.sync="serverUrl"
      :videoCode.sync="videoCode"
      :isLive.sync="isLive"
      @cutAndUploadSuccess="cutAndUploadSuccess"
    >
    </simpleXgPlayer>

    <!-- IE播放器 -->

    <vlcPlayer
      v-if="isIE"
      ref="vlcPlayerRef"
      :width="width ? width.toString() : videoWidth.toString()"
      :height="height ? height.toString() : videoHeight.toString()"
      :videoUrl.sync="videoUrlCopy"
      @cutAndUploadSuccess="cutAndUploadSuccess"
    >
    </vlcPlayer>
  </div>
</template>

<script>
import vlcPlayer from "@/components/videoPlayer/vlcPlayer";
import xgPlayer from "@/components/videoPlayer/xgPlayer";
import simpleFlv from "@/components/videoPlayer/simpleFlv";
import simpleXgPlayer from "@/components/videoPlayer/simpleXgPlayer";
import { isIEBrowser } from "@/utils/index";

export default {
  name: "videoPlayer",
  components: {
    vlcPlayer,
    simpleFlv,
    xgPlayer,
    simpleXgPlayer,
  },
  props: {
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    videoUrl: {
      type: String,
    },
    controls: {
      type: Boolean,
      default: true,
    },
    simpleFlvFlag: {
      type: Boolean,
      default: false,
    },
    limitReloadCount: {
      type: Number,
      default: 10,
    },
    videoCode: {
      type: String,
      default: "mp4", //只支持mp4或MP4
      validator: function (value) {
        // 这个值必须匹配下列字符串中的一个
        return ["flv", "MP4"].indexOf(value) !== -1;
      },
    },
    voice: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: "1",
    },
    isLive: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    videoUrl: {
      immediate: true,
      handler(val) {
        this.videoUrlCopy = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      player: null,
      refDom: null,
      serverUrl: "",
      videoUrlCopy: "",
      isIE: null,
      videoHeight: 750,
      videoWidth: document.documentElement.clientWidth - 302,
      reloadUrlCount: 0,
      checkIframetimer: null,
      lastDecodedFrame: 0,
      lastDecodedFrameCount: 0,
    };
  },

  created() {
    this.isIE = isIEBrowser();
    // this.getServerUrl();
    console.log(this.isIE, "是否ie浏览器");
  },
  mounted() {},
  methods: {
    cutVideoScreen() {
      if (this.isIE) {
        if (this.$refs.vlcPlayerRef) {
          this.$refs.vlcPlayerRef.cutVideoScreen(); // 截屏
        }
      } else {
        if (this.$refs.xgPlayerRef) {
          this.$refs.xgPlayerRef.cutVideoScreen(); // 截屏
        }
      }
    },
    reloadVlcPlayer() {
      // if(this.isIE){
      //     this.$refs.vlcPlayerRef.initvideoPlayer(this.videoUrlCopy);// 截屏
      // }
    },

    pause() {
      // 暂停

      if (this.isIE) {
        if (this.$refs.vlcPlayerRef) {
          this.$refs.vlcPlayerRef.pause(); // 截屏
        }
      } else {
        if (this.$refs.xgPlayerRef) {
          this.$refs.xgPlayerRef.pause(); // 暂停
        }
      }
    },
    play() {
      //播放
      if (this.isIE) {
        if (this.$refs.vlcPlayerRef) {
          this.$refs.vlcPlayerRef.play(); // 播放
        }
      } else {
        if (this.$refs.xgPlayerRef) {
          this.$refs.xgPlayerRef.play(); // 播放
        }
      }
    },

    getServerUrl() {
      // 查询 ServerUrl 地址
      this.$http.get("/sysconfig/liveTransUrl").then((res) => {
        if (res.data.code === "1") {
          this.serverUrl = res.data.data;
        }
      });
    },
    cutAndUploadSuccess(filePath) {
      console.log(filePath, "看看什么东西");
      this.$emit("cutAndUploadSuccess", filePath);
    },
  },

  destroyed() {},
};
</script>

<style lang="less" scoped>
.player-box {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>